import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import i18next from "i18next";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import ScheduleVacationCreatePopup from "./ScheduleVacationCreatePopup";
import YearChooser, {direction} from "../Common/YearChooser";

class ScheduleVacationList extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            holidayScheduleCreateVisible: false,
            methodInfo: null,
//            inOperation: true
        }
    }

    componentDidMount() {
        this.initialize();
    }

    componentDidUpdate(prevProps) {
        if (this.props.currentYear !== prevProps.currentYear) {
            this.initialize();
        }
    }

    initialize = async () => {
//        this.setState({inOperation: true});
        try {
            let key = {"NumYear": this.props.currentYear};
            await this.props.dispatch(this.props.ShedHolidayDetailListForPO.execute(key, {withStyle: true}));
            if(this.props.appParams.showCreateVacationSchedule && this.props.isViewEditSched) {
                await this.props.dispatch(this.props.ShedHolidayDetail_GetMethodPlan.execute(key));
                const methodInfo = this.props.ShedHolidayDetail_GetMethodPlan.getRow(0);
                this.setState({methodInfo: methodInfo});
            }
        } catch (e) {
            console.error(e);
        } finally {
//            this.setState({inOperation: false});
        }
    }

    createHolidaySchedule = async () => {
        this.setState({holidayScheduleCreateVisible: true});
    }

    closeHolidayScheduleCreate = (refresh = false) => {
        this.setState({holidayScheduleCreateVisible: false}, async () => {
            if (refresh) {
                await this.props.dispatch(this.props.ShedHolidayDetailListForPO.refresh());
            }
        })
    }

    render() {
/*
        if(this.state.inOperation)
            return null;
*/
        return (<>
            {
                this.props.appParams.showCreateVacationSchedule && this.props.isViewEditSched &&
                    <button type="button" className="btn btn-regular -goahead my-2"
                            title={i18next.t("Schedule_Vacation_List_1")} onClick={this.createHolidaySchedule}>
                        {i18next.t("Schedule_Vacation_List_1")}
                    </button>
            }
            {
                this.props.ShedHolidayDetailListForPO.rowsCount() === 0 &&
                <div className="my-3">
                    <strong>{i18next.t("PlanVacationsNotFound", {year: this.props.currentYear})}</strong>
                </div>
            }
            {
                this.props.ShedHolidayDetailListForPO.rowsCount() > 0 &&
                <GridView dataItem={this.props.ShedHolidayDetailListForPO} useItemStyle={true}/>
            }
            {
                this.state.holidayScheduleCreateVisible && this.state.methodInfo &&
                <ScheduleVacationCreatePopup currentYear={this.props.currentYear}
                                             dataItem={this.state.methodInfo.MethodNameNum === 1 ? this.props.ShedHolidayDetail_ListYearPO : this.props.ShedHolidayDetail_ListYearDetPO}
                                             onClose={this.closeHolidayScheduleCreate}
                                             readOnly={this.state.methodInfo.IsReadOnly === 1}/>
            }
        </>);
    }
}

ScheduleVacationList.propTypes = {
    dispatch: PropTypes.func.isRequired,
    ShedHolidayDetailListForPO: PropTypes.object,
    ShedHolidayDetail_GetMethodPlan: PropTypes.object,
    currentYear: PropTypes.number,
    ShedHolidayDetail_ListYearPO: PropTypes.object,
    ShedHolidayDetail_ListYearDetPO: PropTypes.object,
    appParams: PropTypes.object,
    isViewEditSched: PropTypes.bool
}

ScheduleVacationList.defaultProps = {
    onChangeCurrentYear: () => {},
    isViewEditSched: false
};

function mapStateToProps(state, ownProps) {
    return {
        ShedHolidayDetailListForPO: state.vacationState.ShedHolidayDetailListForPO,
        ShedHolidayDetail_GetMethodPlan: state.vacationState.ShedHolidayDetail_GetMethodPlan,
        ShedHolidayDetail_ListYearPO: state.vacationState.ShedHolidayDetail_ListYearPO,
        ShedHolidayDetail_ListYearDetPO: state.vacationState.ShedHolidayDetail_ListYearDetPO,
        appParams: state.appState.appParams
    }
}

export default connect(mapStateToProps)(ScheduleVacationList)